import React, { useState } from 'react';
import ApplicationFrame from 'components/ApplicationFrame';
import { Box, Button, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import GetAppIcon from '@mui/icons-material/GetApp';
import { Pagination } from '@mui/material';
import { translate } from 'translations/translator';
import { MIME_TYPE as MimeType } from 'types/enums';
import ModalsTranslationVariant from 'translations/variants/modals';

const getTranslation = (key: ModalsTranslationVariant) => translate('modals', key);

const AttemptFilesModal: React.FC<{ files: any[] }> = ({ files }) => {
  const theme = useTheme();
  const classes = useStyles(theme)();
  const [page, setPage] = useState(1);

  const ApplicationFrame1 = ApplicationFrame as any;

  const renderPreview = file => {
    const { mimeType, filepath } = file;

    if (mimeType.startsWith('image')) {
      return (
        <div className={classes.imagePreview}>
          <img src={filepath} alt={file.title} />
        </div>
      );
    }

    if (mimeType.startsWith('audio')) {
      return (
        <audio>
          <source src={filepath} type={mimeType} />
        </audio>
      );
    }

    if (mimeType.startsWith('video')) {
      return (
        <video>
          <source src={filepath} type={mimeType} />
        </video>
      );
    }

    if (mimeType === MimeType.APPLICATION_PDF) {
      return <ApplicationFrame1 url={filepath} aspectRatio="4/3" heightAdjust={0} />;
    }
  };

  const handlePageChange = (_, next: number) => setPage(next);

  const currentFile = files[page - 1];

  return (
    <Box className={classes.container}>
      {renderPreview(currentFile)}
      <Button
        variant="contained"
        className={classes.downloadButton}
        startIcon={<GetAppIcon />}
        href={currentFile.filepath}
        target="_blank"
      >
        {getTranslation(ModalsTranslationVariant.downloadFile)}
      </Button>
      {files.length > 1 && (
        <Box mt={2} display="flex" justifyContent="flex-end">
          <Pagination
            color="primary"
            count={files.length}
            page={page}
            onChange={handlePageChange}
          />
        </Box>
      )}
    </Box>
  );
};

const useStyles = theme =>
  makeStyles(() => ({
    container: {
      minWidth: '25vw',
      maxWidth: '80vw',
      minHeight: '25vh',
      maxHeight: '70vh',
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      justifyContent: 'space-around',
      alignItems: 'center'
    },
    downloadButton: () => ({
      textTransform: 'none',
      width: 'inherit',
      margin: theme.spacing(2),
      '&:hover': {
        color: theme.palette.common.white,
        textDecoration: 'none'
      }
    }),
    imagePreview: {
      maxWidth: '100%',
      maxHeight: '80%',
      overflow: 'scroll'
    }
  }));

export default AttemptFilesModal;
